"use client"

import { t } from "@/languages/i18n"
import { DatePicker, Form, FormInstance, Input, Radio, Select } from "antd"
import dayjs from "dayjs"
import React from "react"

interface CampaignSubscriberUpsertFormProps {
  form: FormInstance
  campaignOptions: { label: string; value: number }[]
  onFormChange: () => void
}

const CampaignSubscriberUpsertForm: React.FC<CampaignSubscriberUpsertFormProps> = ({
  form,
  campaignOptions,
  onFormChange,
}) => {
  return (
    <Form form={form} layout="vertical" onValuesChange={onFormChange}>
      <div className="grid grid-cols-2 gap-4">
        <Form.Item
          name="fullname"
          label={<span className="text-base font-medium">{t("Full name")}</span>}
          rules={[{ required: true, message: t("Please enter full name") }]}
        >
          <Input placeholder={t("Enter full name")} />
        </Form.Item>

        <Form.Item
          name="phone"
          label={<span className="text-base font-medium">{t("Phone")}</span>}
          rules={[
            { required: true, message: t("Please enter phone number") },
            { pattern: /^[a-zA-Z0-9]+$/, message: t("Số điện thoại phải là 0-9") },
          ]}
        >
          <Input placeholder={t("Enter phone")} />
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Form.Item
          name="email"
          label={<span className="text-base font-medium">{t("Email")}</span>}
          rules={[{ type: "email", message: t("Invalid email format") }]}
        >
          <Input placeholder={t("Enter email")} />
        </Form.Item>

        <Form.Item name="invoiceNumber" label={<span className="text-base font-medium">{t("Invoice number")}</span>}>
          <Input placeholder={t("Enter invoice number")} />
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Form.Item
          name="branch"
          label={<span className="text-base font-medium">{t("Branch")}</span>}
          rules={[{ required: true, message: t("Please enter branch") }]}
        >
          <Input placeholder={t("Enter branch")} />
        </Form.Item>

        <Form.Item
          name="purchasingDate"
          label={<span className="text-base font-medium">{t("Purchasing date")}</span>}
          rules={[{ required: true, message: t("Please select date") }]}
          getValueProps={value => ({ value: value ? dayjs(value) : undefined })}
          normalize={value => (value ? value.toISOString() : "")}
        >
          <DatePicker
            className="w-full"
            format="DD/MM/YYYY"
            showTime={{ format: "HH:mm" }}
            placeholder={t("Select date and time")}
          />
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Form.Item name="campaign" label={<span className="text-base font-medium">{t("Campaign")}</span>}>
          <Select
            placeholder={t("Select campaign")}
            options={campaignOptions}
            allowClear
            showSearch
            filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
          />
        </Form.Item>

        <Form.Item name="resolved" label={<span className="text-base font-medium">{t("Resolved")}</span>}>
          <Radio.Group buttonStyle="solid">
            <Radio.Button value={false}>{t("False")}</Radio.Button>
            <Radio.Button value={true}>{t("True")}</Radio.Button>
          </Radio.Group>
        </Form.Item>
      </div>
    </Form>
  )
}

export default CampaignSubscriberUpsertForm
